<template>
  <!-- 组件主盒子 -->
  <div>
    <div class="query-select">
      <el-form
        ref="queryForm"
        :model="queryForm"
        :inline="true"
        class="user-search"
      >
        <el-form-item label="题干：">
          <el-input
            size="small"
            v-model="queryForm.questionStem"
            placeholder="请输入题干"
          ></el-input>
        </el-form-item>

        <el-form-item label="题型：">
          <el-cascader
            :options="typeOptions"
            v-model="queryType"
            @change="queryTypeChange"
            :props="{ checkStrictly: true }"
          >
          </el-cascader>
        </el-form-item>
        <!-- <el-form-item label="题型：">
          <el-select
            size="small"
            v-model="queryForm.questionType"
            placeholder="请选择题型"
            @change="getList"
          >
            <el-option label="单选" value="1"></el-option>
            <el-option label="多选" value="3"></el-option>
            <el-option label="判断" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="删除日期：" class="mr-left">
          <el-date-picker
            size="small"
            @change="dateChange"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getList"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="review"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-refresh-right"
          plain
          size="small"
          round
          @click="recycleAll"
          >全部恢复</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          plain
          size="small"
          round
          @click="deleteAll"
          >全部删除</el-button
        >
      </div>
    </div>

    <!-- 分割 -->
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        border
        stripe
        size="small"
        v-loading="loading"
        header-cell-class-name="table-header"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column align="center" prop="type" label="类型">
        </el-table-column>
        <el-table-column align="center" prop="questionType" label="题型">
        </el-table-column>
        <el-table-column
          align="center"
          prop="questionStem"
          label="题干"
          width="500"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="questionAnswer"
          label="答案"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" prop="createTime" label="删除日期">
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              plain
              size="mini"
              round
              type="success"
              @click="recycleClick(scope.row.id)"
              >恢复</el-button
            >
            <el-button
              type="danger"
              plain
              size="mini"
              round
              @click="removeClick(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="10"
        layout="total, prev, pager, next"
        :current-page.async="queryForm.pageNum"
        :total="totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getRecycleList, delRecycle, addRecycle } from "@/api/manage";
import { deleteAll, recoverAll } from "@/api/question";
import { tansParams } from "@/utils/util";
import { handsOnQuestionTypes, examLevel } from "@/utils/dict.js";

export default {
  name: "BankRecycle",
  data() {
    return {
      loading: false,
      //   搜索栏
      queryForm: {
        questionStem: null,
        questionType: "",
        pageNum: 1,
        pageSize: 10
      },
      queryType: null,
      typeOptions: [
        {
          value: 1,
          label: "理论试题",
          children: [
            { label: "单选", value: 1 },
            { label: "多选", value: 3 },
            { label: "判断", value: 2 }
          ]
        },
        {
          value: 2,
          label: "实操试题",
          children: handsOnQuestionTypes
        }
      ],
      tableData: [],
      dateRange: [],
      totalCount: 100
    };
  },
  computed: {
    questionTypesOptions() {
      return handsOnQuestionTypes;
    }
  },
  methods: {
    queryTypeChange(val) {
      if (val && val.length > 0) {
        this.queryForm.type = val[0];
        if (val.length > 1) {
          this.queryForm.questionType = val[1];
        }
      }
      this.getList();
    },
    // 获取表格数据
    async getList() {
      this.loading = true;
      // const params = tansParams(this.queryForm);
      getRecycleList(this.queryForm).then(res => {
        this.tableData = res.data.data.rows.map(i => ({
          ...i,
          type: i.type == 1 ? "理论试题" : "实操试题",
          questionType:
            i.type == 1
              ? i.questionType == 1
                ? "单选题"
                : i.questionType == 3
                ? "多选题"
                : i.questionType == 2
                ? "判断题"
                : ""
              : this.questionTypesOptions.find(
                  item => item.value == i.questionType
                ).label,
          questionStem: i.questionStem
        }));
        this.totalCount = res.data.data.total;
        this.loading = false;
      });
    },
    dateChange(val) {
      if (val) {
        this.queryForm.createTimeStart = val[0] + " 00:00:00";
        this.queryForm.createTimeEnd = val[1] + " 23:59:59";
      }
      this.getList();
    },
    review() {
      this.queryForm.questionStem = null;
      this.queryForm.questionType = "";
      this.queryForm.params = null;
      this.queryForm.createTimeStart = null;
      this.queryForm.createTimeEnd = null;
      this.dateRange = [];
      this.queryType = null;
      this.getList();
    },
    // 恢复单条
    async recycleClick(id) {
      this.$confirm("是否恢复该试题?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success"
      })
        .then(async () => {
          addRecycle(id).then(res => {
            this.getList();
            this.$message.success("恢复成功");
          });
        })
        .catch(() => {});
    },
    // 删除单条
    async removeClick(id) {
      this.$confirm("此操作将永久删除该试题，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          delRecycle(id).then(res => {
            this.getList();
            this.$message.success("删除成功");
          });
        })
        .catch(() => {});
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getList();
    },
    recycleAll() {
      this.$confirm("确定要全部恢复吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          recoverAll().then(res => {
            this.$message.success("恢复成功");
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作！"
          });
        });
    },
    deleteAll() {
      this.$confirm("确定要全部删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteAll().then(res => {
            this.$message.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作！"
          });
        });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
.table-style {
  font-size: 0.875rem;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  // font-weight: 400;
  color: rgba(51, 51, 51, 0.8);

  // width: 100%;
  // height: 93.75%;
  padding: 1rem;
  // border: 1px solid red;
  background: #ffffff;
  border-radius: 0.375rem;
  // background-color: red;

  .button-style {
    // font-size: 0.875rem;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Bank/BankRecycle/index.vue